import { render, staticRenderFns } from "./product-questions.vue?vue&type=template&id=7acf1402&"
import script from "./product-questions.vue?vue&type=script&lang=js&"
export * from "./product-questions.vue?vue&type=script&lang=js&"
import style0 from "./product-questions.vue?vue&type=style&index=0&id=7acf1402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports